import * as React from 'react';

export default () => (
  <svg width="12" height="12">
    <g stroke="#FFF" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round">
      <path d="M1 1l10 10M11 1L1 11" />
    </g>
  </svg>
);
